import { PageController } from '@client/components/_core/layout/PageController';
import { AuthorisedAppsManager } from '@client/components/authorised-apps/AuthorisedAppsManager';
import { createFileRoute } from '@tanstack/react-router';

/**
 * /console/$orgId/user-settings/authorised-apps
 *
 * Lists + revokes the PATs the calling user has minted against this tenant org (via OAuth from an MCP
 * client like Claude Code). The table is shared with the admin-console route
 * (`/admin-console/authorised-apps`) — see `AuthorisedAppsManager`; the list/revoke endpoints scope
 * to `ctx.user.orgId`, so each route shows the tokens for its own org context.
 */

export const Route = createFileRoute('/console/$orgId/user-settings/authorised-apps/')({
    staticData: {
        metadata: { title: 'Authorised apps' },
        ui: { title: 'Authorised apps', widthVariant: 'compact' },
        // Hidden when the MCP server feature flag is off (review finding #6). This is the
        // whole client-side gate: the route registry records it (so the AI navigation tool
        // and menus hide the page) and `RouteAccessGuard` in the console layout enforces it
        // for deep links — showing a loader while PostHog is still evaluating and `NotFound`
        // only once the value is definitive. A component-level `<Navigate to="/not-found">`
        // on the raw `useFeatureFlag` value used to sit below too; it was redundant with the
        // guard and, unlike it, could not tell "off" from "not loaded yet" (see the admin-
        // console counterpart, which had no guard and 404ed mid-evaluation). Server-side
        // matching gate in personalAccessTokens/{list,revoke}.ts returns NOT_FOUND too.
        featureFlag: 'enable-mcp-server',
    },
    component: AuthorisedAppsPage,
});

function AuthorisedAppsPage() {
    return (
        <PageController route={Route}>
            <AuthorisedAppsManager />
        </PageController>
    );
}
